import { locales } from "@i18n/react";
import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  defaultLocale: "en",
  localePrefix: "as-needed",
  locales,
  localeCookie: { maxAge: 60 * 60 * 24 * 365 },
});
